import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'ngx-zcs-components';
import { MatButtonModule } from '@angular/material/button';
import { GraphqlApiService, RoleService, wait } from 'ngx-core-services';
import { Router, RouterModule } from '@angular/router';
import { MenuModule } from 'ngx-zcs-blocks';

import { AppsyncEnvSelectorComponent, LanguageSelectorComponent, RefreshSelectorComponent } from '@customerComponents';

import { environment } from '../../../../environments/environment';
import { LanguageService, RefreshService } from '../../services';
import { SharedModule } from '../../shared.module';
import { TodayModeService } from '../../services/today-mode.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    forwardRef(() => AppsyncEnvSelectorComponent),
    forwardRef(() => LanguageSelectorComponent),
    forwardRef(() => RefreshSelectorComponent),
    MatButtonModule,
    MatIconModule,
    MenuModule,
    RouterModule,
    SharedModule,
    TooltipModule,
  ],
  selector: 'customer-sidebar-right',
  templateUrl: './sidebar-right.component.html',
  styleUrls: ['./sidebar-right.component.scss'],
})
export class SidebarRightComponent {
  @Input() user?: {
    email: string | null;
    photoURL: string | null;
    displayName: string | null;
  } | null;
  @Input() toggleSidebarRight?: () => void;
  @Input() withRefresh = true;
  @Input() withLanguage = true;
  @Input() withIdentityAreaNavigation = true;
  @Input() withZCSOperatorAreaNavigation = true;
  @Input() withKioskMode = true;

  @Output() readonly logout = new EventEmitter<void>();

  readonly is_ZCS_Operator$ = this.roleService.is_ZCS_Operator$;
  readonly is_developer$ = this.roleService.is_developer$;
  readonly has_somePermission$ = this.roleService.has_somePermission$;
  readonly envGateway$ = this.graphqlApiService.envGateway$;

  readonly refresh$ = this.refreshService.refresh$;
  readonly version = environment.version;
  readonly tooltipsTemplatePosition: Partial<ConnectedPosition> = {
    originX: 'start',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'top',
    offsetX: 12,
  };

  readonly currentLang$ = this.languageService.currentLang$;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
    private readonly roleService: RoleService,
    private readonly router: Router,
    readonly languageService: LanguageService,
    readonly refreshService: RefreshService,
    readonly todayModeService: TodayModeService,
  ) {}

  async changeTodayMode() {
    this.todayModeService.changeTodayMode();
    await wait(200);
    this.refreshService.refresh$.next();
  }

  goToIdentityRegistration() {
    this.router.navigate(['/identity-registration']);
  }

  goToMigrationRequest() {
    this.router.navigate(['/migration-request']);
  }
}
